document.addEventListener('DOMContentLoaded', () => {
  const button = document.getElementById('floating-menu-button');
  const menu = document.getElementById('floating-menu');
  const overlay = document.getElementById('floating-menu-overlay');
  const closeButton = document.getElementById('floating-menu-close');

  const openMenu = () => {
    if (!menu || !overlay) return;
    menu.classList.add('is-open');
    overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  };

  const closeMenu = () => {
    if (!menu || !overlay) return;
    menu.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  };

  const toggleSubmenu = (element) => {
    const submenuId = element.getAttribute('data-submenu-id');
    const submenu = document.getElementById(submenuId);
    if (!submenu) return;

    const isExpanded = element.getAttribute('aria-expanded') === 'true';
    const newExpandedState = !isExpanded;
    element.setAttribute('aria-expanded', newExpandedState);
    submenu.classList.toggle('is-open');

    // Also update the toggle button if it exists (when clicking the link)
    const toggleButton = document.querySelector(`.floating-menu__submenu-toggle[data-submenu-id="${submenuId}"]`);
    if (toggleButton && toggleButton !== element) {
      toggleButton.setAttribute('aria-expanded', newExpandedState);
    }

    // Update the link button if it exists (when clicking the arrow)
    const linkButton = document.querySelector(`.floating-menu__link--has-submenu[data-submenu-id="${submenuId}"]`);
    if (linkButton && linkButton !== element) {
      linkButton.setAttribute('aria-expanded', newExpandedState);
    }
  };

  if (button) {
    button.addEventListener('click', openMenu);
  }

  if (closeButton) {
    closeButton.addEventListener('click', closeMenu);
  }

  if (overlay) {
    overlay.addEventListener('click', closeMenu);
  }

  // Handle clicks on submenu toggle buttons (arrows)
  document.querySelectorAll('.floating-menu__submenu-toggle').forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      toggleSubmenu(toggle);
    });
  });

  // Handle clicks on links that have submenus
  document.querySelectorAll('.floating-menu__link--has-submenu').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      toggleSubmenu(link);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.classList.contains('is-open')) {
      closeMenu();
    }
  });

  // Close menu when clicking account link or any footer link
  const footerLinks = menu?.querySelectorAll('.floating-menu__footer .floating-menu__icon-button[href]');
  if (footerLinks) {
    footerLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        // Allow the link to navigate, but close the menu
        setTimeout(() => {
          closeMenu();
        }, 100);
      });
    });
  }
});
